module.exports = __webpack_public_path__ + "f5c20bf074d318f380c60e033225cb8e.MP3";